import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetCurrentUrlService extends Service {
  constructor({repository}) {
    super({repository})
    this._repository = repository
  }

  @inlineError
  async execute() {
    const [error, urlVO] = await this._repository.getCurrentUrl()

    if (error) {
      return Promise.reject(error)
    }

    return urlVO
  }
}
